import React from 'react';
import {
    Form,
    useForm,
    Errors,
    FORM_VALIDATORS,
    H2,
} from '/src/components';
import { getCookie, removeCookie } from '/src/utils';
import { VIP } from '/src/consts';
import { cloudflareGetRecaptchaToken, cloudflareUseRecaptcha } from '/src/services';
import * as styles from './styles.scss';

const CreateCustomer = ({
    createCustomer,
    onSuccess,
    isLoading,
    translate,
    cloudflareSiteKey,
}) => {
    const {
        data,
        errors,
        setErrors,
        fieldsErrors,
        handleChange,
        validateData,
    } = useForm(
        {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            confirmPassword: '',
        },
        {
            firstname: { isRequired: true },
            lastname: { isRequired: true },
            email: { isRequired: true },
            password: {
                isRequired: true,
                validator: FORM_VALIDATORS.password,
            },
            confirmPassword: {
                isRequired: true,
                validator: FORM_VALIDATORS.sameAsField,
                field: 'password'
            }
        }
    );

    const { cloudflareResetRecaptcha } = cloudflareUseRecaptcha(cloudflareSiteKey, '#cf-turnstile');

    const handleSubmit = e => {
        e.preventDefault();
        const isValidData = validateData();
        const { confirmPassword, ...input } = data;

        if (getCookie(VIP)) {
            input.vip_status = true;
        }

        const recaptchaToken = cloudflareGetRecaptchaToken();

        if (!recaptchaToken) {
            setErrors([{ message: 'Check recaptcha' }]);
        } else if (isValidData) {
            createCustomer({ input }, { 'cf-turnstile-response': recaptchaToken })
                .then(() => {
                    removeCookie(VIP);
                    onSuccess();
                }).catch(errors => {
                    cloudflareResetRecaptcha();
                    setErrors(errors);
                });
        } else if (!!errors?.find(({ message }) => message === 'Check recaptcha')) {
            setErrors(null);
        }
    };

    return (
        <>
            <H2 className={styles.title}>
                {translate('Create account')}
            </H2>
            <Errors errors={errors} translate={translate} />
            <Form onSubmit={handleSubmit}>
                <Form.Column mb>
                    <Form.Input
                        label={translate('First name')}
                        name="firstname"
                        value={data.firstname}
                        onChange={handleChange}
                        error={translate(fieldsErrors.firstname)}
                    />
                </Form.Column>
                <Form.Column mb>
                    <Form.Input
                        label={translate('Last name')}
                        name="lastname"
                        value={data.lastname}
                        onChange={handleChange}
                        error={translate(fieldsErrors.lastname)}
                    />
                </Form.Column>
                <Form.Column mb>
                    <Form.Input
                        label={translate('Email')}
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                        error={translate(fieldsErrors.email)}
                    />
                </Form.Column>
                <Form.Column mb>
                    <Form.InputPassword
                        label={translate('Password')}
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                        error={translate(fieldsErrors.password)}
                        autoComplete="current-password"
                    />
                </Form.Column>
                <Form.Column mb>
                    <Form.Input
                        label={translate('Confirm password')}
                        type="password"
                        name="confirmPassword"
                        value={data.confirmPassword}
                        onChange={handleChange}
                        error={translate(fieldsErrors.confirmPassword)}
                        autoComplete="current-password"
                    />
                </Form.Column>
                <div id="cf-turnstile" />
                <Form.Column mt>
                    <Form.Button disabled={isLoading}>
                        {translate('Submit')}
                    </Form.Button>
                </Form.Column>
            </Form>
        </>
    )
};

export default CreateCustomer;
